// removed by extract-text-webpack-plugin
module.exports = {"caret":"Caret__caret___2eF1K","icn-for-submenu":"Caret__icn-for-submenu___3_YOP"};